export enum RowsDescriptorType {
  Loading = 'loading',
  Update = 'update',
}
